module.exports = __webpack_public_path__ + "img/artsy-bg.7890543d.jpg";